import React from 'react';
import { Typography } from '@mui/material';

type StatsCardProps = {
  imgSrc?: string;
  imgAlt?: string;
  title: string;
  subtitle: string;
  textColor?: string;
  className?: string;
};

const StatsCard: React.FC<StatsCardProps> = ({ imgSrc, imgAlt, title, subtitle, className }) => {
  return (
    <div
      className={`p-8 md:p-12 rounded-3xl flex md:flex-col lg:min-h-[300px] gap-x-4 justify-between ${className}`}
    >
      <img src={imgSrc} alt={imgAlt} className="size-10 md:size-14" />
      <div className="text-end mt-auto">
        <Typography variant="title-mac-sans-2xl">{title}</Typography>
        <Typography variant="h4">{subtitle}</Typography>
      </div>
    </div>
  );
};

export default StatsCard;
